




































































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import Context from "@/mixins/context";
import ProvisionRquestsInjectorMixin from "@/mixins/provisionRequestsInjectorMixin";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { AdminRoutes, ClientRoutes } from "@/data/enums/router";
import { ProvisionRequestStatusCodes as PRSC } from "@/data/enums/contractProducts";
import { RequestStatuses } from "@/data/status";
import { LogoSize, LogoType } from "@/data/enums/logos";

// Types
import { IProvisionRequest } from "@/models/provisioning";
import { CreateElement } from "vue";

// Functional Components
import ProvisionRequestStatus from "@/components/app/admin/provisioning/provisionRequestStatus.vue";
import { Location as VueLocation } from "vue-router";

@Component({
  components: {
    "product-image": () =>
      import("@/components/app/global/products/productImage.vue")
  }
})
export default class ProvisionRequestRowItem extends Mixins(
  Context,
  ProvisionRquestsInjectorMixin
) {
  // Props

  @Prop({ default: null })
  public request!: IProvisionRequest;

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: true })
  public showContractProduct!: boolean;

  // Methods

  public actorComponent(request) {
    return this.$store.getters[`data/${DataModules.LOGS}/getActorComponent`](
      request.actor_type,
      request.user_id,
      request.actor
    );
  }

  public getStatusProp(prop) {
    return _.get(RequestStatuses, `${this.statusCode}.${prop}`, "");
  }

  public getProviderRoute(providerName) {
    return {
      name: "adminCatalogueProvisioning",
      query: {
        PCLP1: `1;20;name;provider.name|=|${providerName}`
      }
    };
  }

  public providerLogo(provider) {
    return {
      image: {
        full_url: _.get(
          _.find(
            _.get(provider, "logos", []),
            logo => logo.type === LogoType.ICON && logo.size === LogoSize.TWO_X
          ),
          "url",
          ""
        )
      },
      name: _.get(provider, "name", "")
    };
  }

  public requestStatusIcon(h, style = {}) {
    return h("span", { style }, [
      h(ProvisionRequestStatus, {
        props: {
          statusCode: this.statusCode,
          active: false
        }
      })
    ]);
  }

  // Computed

  public get showSkeletons() {
    return _.isNull(this.request);
  }

  public get isError() {
    return this.statusCode === PRSC.PROVISION_REQUEST_ERROR;
  }

  public get imageSize() {
    if (!this.showContractProduct) return "2.375rem";
    return "3rem";
  }

  public get statusCode() {
    return this.request?.status?.code;
  }

  public get cProd() {
    return this.request?.order_product;
  }

  public get cProdName() {
    return this.$store.getters[`data/${DataModules.CONTRACTS_PRODUCTS}/name`](
      this.cProd
    );
  }

  public get cProdCategoryName() {
    return (
      this.cProd?.product?.category?.name_translated ||
      this.cProd?.product?.category?.name
    );
  }

  public get product() {
    return _.get(this.request, "order_product.product", {});
  }

  public get cProdProvisioningRoute(): VueLocation {
    return {
      name: this.isAdmin
        ? AdminRoutes.CONTRACT_PRODUCT_PROVISIONING
        : ClientRoutes.CONTRACT_PRODUCT_OVERVIEW,
      params: {
        clientId: this.request?.client_id,
        contractId: this.cProd?.contract_id || "",
        productId: this.cProd?.id || ""
      }
    };
  }

  public get statusSummary() {
    return {
      render: (h: CreateElement) =>
        h(
          "p",
          {
            class: [this.getStatusProp("type").replace("is-", "has-text-")]
          },
          [
            h("strong", this.getStatusProp("label") as string),
            " ",
            h("datetime", {
              key: this.request?.id,
              props: {
                type: "strong",
                datetime: this.request?.[this.getStatusProp("dateStamp")] || ""
              }
            })
          ]
        )
    };
  }

  public get statusSummaryIcon() {
    return {
      render: (h: CreateElement) =>
        this.requestStatusIcon(h, { fontSize: "14px" })
    };
  }
}
